<template>
  <b-container fluid>
    <b-row class="mb-4">
      <b-col md="2" order="1">
        <h3>
          <b-badge variant="primary">
            Household
          </b-badge>
          <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
        </h3>
      </b-col>
      <b-col md="5" order="3" order-md="2">
        <b-button 
          block
          @click="$router.push({path: `/contactdetails/${HHID}`})">
          Full names and contacts
        </b-button>
      </b-col>
      <b-col md="5" order="2" order-md="3" class="pb-md-0 pb-2">
        <b-button 
          block
          @click="$router.go(-1)">
          Back
        </b-button>
      </b-col>
    </b-row>
    <b-table 
      small 
      responsive 
      striped
      stacked="sm"
      :busy="waiting"
      :fields="fields" 
      :items="items">
      <template slot="AdditionalDetails" slot-scope="data">
        <b-button
          @click="$router.push({path: `/individualdetails/${data.item.HHID}/${data.item.PID}`})">
          Individual Details
        </b-button>
      </template>
      <template slot="ChosenForInterview" slot-scope="data">
        <b-form-checkbox
          disabled
          v-model="data.item.ChosenForInterview">
        </b-form-checkbox>
      </template>
      <div slot="table-busy" class="text-center text-danger">
        <b-spinner class="align-middle"></b-spinner>
        <!-- <strong>Loading...</strong> -->
      </div>
    </b-table>
  </b-container>
</template>

<script>
import { apiService } from '../_services'

export default {
  name: 'Household',
  data() {
    return {
      waiting: false,
      HHID: '',
      items: [],
      fields: [
        // fake field with button
        {
          key: 'AdditionalDetails',
          label: ''
        },
        {
          key: 'PID',
          label: 'PID'
        },
        {
          key: 'CSM',
          label: 'CSM'
        },
        {
          key: 'HHID',
          label: 'HH ID'
        },
        {
          key: 'ClaimID',
          label: 'Claim ID'
        },
        {
          key: 'FamilyName',
          label: 'Family Name'
        },
        {
          key: 'FirstName',
          label: 'First Name'
        },
        {
          key: 'DOB',
          label: 'DOB'
        },
        {
          key: 'Sex',
          label: 'Sex'
        },
        {
          key: 'ChosenForInterview',
          label: 'Chosen for interview'
        },
        {
          key: 'OutcomeToDate',
          label: 'Outcome to date'
        }
      ]
    }
  },
  created() {
    this.HHID = this.$route.params.hhid
    let vm = this
    this.waiting = true
    apiService.getHousehold(this.HHID)
    .then((response) => {
      vm.items = response.data
      vm.waiting = false
    })
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/HouseholdPage.vue